import React from 'react';
import { Button } from '../../ui';
import { TrashIcon } from '@heroicons/react/24/outline';

const BulkRemoveDialog = ({
  isOpen,
  onClose,
  mode = 'selected',
  selectedChatsCount = 0,
  filterMatchCount = 0,
  filterDescription = '',
  onConfirmRemove,
}) => {
  if (!isOpen) return null;

  const isFilterMode = mode === 'filter';
  const visibleCount = isFilterMode ? filterMatchCount : selectedChatsCount;
  const noun = visibleCount === 1 ? 'group' : 'groups';

  const title = isFilterMode
    ? 'Remove All Matching Groups'
    : `Remove Selected Groups`;
  const description = isFilterMode
    ? `Are you sure you want to remove ${visibleCount} ${noun} matching the current filters${
        filterDescription ? ` (${filterDescription})` : ''
      }? These groups will no longer be monitored for keyword matches.`
    : `Are you sure you want to remove ${visibleCount} ${noun} from this project? These groups will no longer be monitored for keyword matches.`;
  const confirmLabel = isFilterMode
    ? `Remove ${visibleCount} Matching`
    : `Remove ${visibleCount} ${noun.charAt(0).toUpperCase() + noun.slice(1)}`;

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose}></div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <TrashIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                  {title}
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    {description}
                  </p>
                  {isFilterMode && visibleCount > 0 && (
                    <p className="mt-2 text-xs text-amber-700">
                      Heads up: this will remove every group matching the current filters across all pages, not just the ones on this screen.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <Button
              variant="danger"
              onClick={onConfirmRemove}
              disabled={visibleCount === 0}
              className="sm:ml-3"
            >
              {confirmLabel}
            </Button>
            <Button
              variant="secondary"
              onClick={onClose}
              className="mt-3 sm:mt-0"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkRemoveDialog;